import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { ConsoleLogger } from "@microsoft/signalr/dist/esm/Utils";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { DashboardService } from "src/app/services/dashboard.service";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { Page } from "src/app/shared/models/Page";

@Component({
   selector: "app-documentos-emitidos-widget",
   templateUrl: "./documentos-emitidos-widget.component.html",
   styleUrls: ["./documentos-emitidos-widget.component.scss"],
})
export class DocumentosEmitidosWidgetComponent implements OnInit {
	private unsubscribe$ = new Subject<void>();
   loading: boolean;
   emisorId: string;
   sucursalId: string;
   public usuarioId: string;
   public planActual: PlanUsuario;
   public enMora: boolean = false;
   constructor(private planService: PlanUsuarioService, 
	private changeCompanyService: ChangeCompanyService,
	private tokenService: TokenStorageService, private ref: ChangeDetectorRef) {
      this.emisorId = this.tokenService.getCompany();
      this.sucursalId = this.tokenService.getSubsidiary();
      this.usuarioId = tokenService.getUser().id;
   }

   abrirPDF(): void {
    const url = './assets/deployAssets/ComoPagarSimpleFactura.pdf';
    const width = 800;
    const height = 600;

    // Calcular la posición para centrar la ventana en la pantalla
    const left = (window.screen.width / 2) - (width / 2);
    const top = (window.screen.height / 2) - (height / 2);

    // Abrir la ventana emergente con las opciones de posición y tamaño
    window.open(url, '_blank', `width=${width},height=${height},top=${top},left=${left}`);
  }
   	cargar(){
		this.loading = true;
		this.planService
			.getContratacionDataByCompany(this.emisorId)
			.subscribe(
				(pagedData) => {
					let elements = pagedData as PlanUsuario[];
					this.ref.detectChanges();
					this.loading = false;
					this.ref.detectChanges();
					this.planActual = elements.find((x) => x.emisorId == this.emisorId);
               if (this.planActual && this.planActual.fechaCaducidad) {
                  const caducidad = new Date(this.planActual.fechaCaducidad);
                  const ahora = new Date();
                  this.enMora = caducidad < ahora;
               }
            },
				(error) => {
					console.log("ERROR", error);
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}
   ngOnInit(): void {
	this.changeCompanyService.companyChanged
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((newEmisor: Emisor) => {
        this.usuarioId = this.tokenService.getUser().id;
        this.emisorId = newEmisor.emisorId;
        this.cargar();
      });
    this.cargar();
   }

   ngOnDestroy(): void {
    // Emitir para desuscribirse de los observables
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}

